// src/pages/CalendarV2.jsx
import React from "react";
import { useIsMobile } from "../hooks/useIsMobile";
import CalendarPcLayout from "../layouts/calendar/CalendarPcLayout";
import CalendarMobileLayout from "../layouts/calendar/CalendarMobileLayout";

export default function CalendarV2() {
  const isMobile = useIsMobile();
  return isMobile ? <CalendarMobileLayout /> : <CalendarPcLayout />;
}
